import React from 'react';
import { Box, BoxProps, Collapse, Divider, MenuList } from '@mui/material';

// use dotStyle
export const Dot = ({
  size = 10,
  color,
  ...props
}: Omit<BoxProps, 'color' | 'component'> & {
  size?: BoxProps['width'];
  color?: BoxProps['bgcolor'];
}) => <Box component="span" width={size} height={size} bgcolor={color} borderRadius="50%" {...props} />;

const StyledDivider = (props: BoxProps<typeof Divider>) => (
  <Box
    component={Divider}
    borderColor="var(--color-border-base-primary)"
    mx={1.25}
    {...props}
    sx={{ '&:has(+ :empty)': { display: 'none' }, ...props.sx }}
  />
);

export type ChartTooltipProps = BoxProps & {
  titleSlot?: React.ReactNode;
  interactionsMenuOpen?: boolean;
  interactions?: React.ReactNode;
};

export const ChartTooltip = ({ children, titleSlot, interactionsMenuOpen = false, interactions, ...props }: ChartTooltipProps) => (
  <Box bgcolor="var(--color-surface-immutable-darkGrey)" borderRadius="10px" overflow="hidden" {...props}>
    <Box px={1.25} pt={1} bgcolor="var(--color-surface-immutable-darkGrey)">
      {titleSlot}
    </Box>

    {titleSlot ? <StyledDivider my={1.25} /> : null}

    <Box sx={{ width: '100%', px: 1.25, '&:empty': { display: 'none' }, '&:has(~ .MuiBox-root.interactions:empty)': { pb: 1.25 } }}>
      {children}
    </Box>

    <StyledDivider mt={1.25} borderColor={interactionsMenuOpen ? 'transparent' : 'var(--color-border-base-primary)'} />

    <Collapse in={interactionsMenuOpen} collapsedSize={41} sx={{ '&:has(.interactions:empty)': { display: 'none' } }}>
      <Box
        component={MenuList}
        className="interactions"
        disablePadding
        sx={{
          '&:empty': { display: 'none' },
          pb: 1,
          px: 0,
          pt: interactionsMenuOpen ? 1 : 0.5,
          transition: t => t.transitions.create(['background-color', 'padding-top'], { duration: t.transitions.duration.complex }),
          backgroundColor: interactionsMenuOpen ? 'var(--color-surface-base-primary)' : 'var(--color-surface-immutable-darkGrey)',
        }}>
        {interactions}
      </Box>
    </Collapse>
  </Box>
);
